<template>
  <div class="salon">
    <router-view>

    </router-view>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.salon {
  font-family: Noto Sans SC-Medium, Noto Sans SC;
  height: 100vh;
  overflow: scroll;
}
</style>

<style lang="scss">
.salon-chaxie {
  margin-left: 5px;
  color: #e7635e;
}
</style>